import DevExpressDataGrid from 'components/inheritComponent/devexpressdatagrid';
import React, { Component } from 'react';
import { addURL } from 'redux/actions/url';
import ModalUploadiuran from 'components/pages/modal/participant/iuran/uploadIuran';
import ModalKirimIuranBulanan from './modals/showModalKirimIuranBulanan';
import ModalDetailIuranBulanan from './modals/showModalDetailIuranBulanan';
import { confirm } from 'devextreme/ui/dialog';
import notify from "devextreme/ui/notify";
import httpRequest from 'plugin/httprequest';
import { months } from 'dataSource/lookup';

class IuranBulanan extends Component {
    constructor(props) {
        super(props)

        this.participantId = this.props.store.getState().sessionUser ? this.props.store.getState().sessionUser.participantId : 0

        this.dataGridRef = React.createRef()
        this.uploadIuranRef = React.createRef()
        this.modalKirimRef = React.createRef()
        this.modalDetailIuranBulananRef = React.createRef()

        this.columns = [
            {
                type: 'buttons',
                buttons: [
                    'edit',
                    {
                        text: 'Detail',
                        hint: 'edit',
                        onClick: (e) => {
                            this.showModalDetilIuranBulanan(e.row.data)
                        }
                    },
                    {
                        text: 'Kirim',
                        hint: 'edit',
                        onClick: (e) => {
                            this.showModalKirim(e.row.data, 'approved')
                        }
                    },
                    {
                        text: 'Batal',
                        hint: 'edit',
                        onClick: async (e) => {
                            let result = await confirm(`Apakah anda yakin membatalkan data ini?`, "Konfirmasi");
                            if (result) {
                                this.processBatalIuran(e.row.data)
                            }
                        }
                    }
                ],
            },
            {
                dataField: 'no',
                caption: 'No.',
                cellRender: (e) => {
                    return e.rowIndex + 1
                },
                width: "50px"
            },
            {
                dataField: 'fileName',
                caption: 'Nama File',
                visible: false
            },
            {
                dataField: 'tahun',
                caption: 'Iuran Tahun',
                alignment: 'right'
            },
            {
                dataField: 'bulan',
                caption: 'Iuran Bulan',
                lookup: {
                    dataSource: months,
                    valueExpr: 'id',
                    displayExpr: 'value'
                }
            },
            {
                dataField: 'uploadDate',
                caption: 'Tanggal Upload',
                dataType: 'date',
                format: 'dd MMM yyyy'
            },
            {
                dataField: 'pesertaAmount',
                caption: 'Jumlah Peserta',
                dataType: 'number',
                format: '#,##0',
                alignment: 'right'
            },
            {
                dataField: 'productAmount',
                caption: 'Produk Dana Pensiun',
                dataType: 'number',
                format: '#,##0',
                alignment: 'right'
            },
            {
                dataField: 'iuranPesertaTotal',
                caption: 'Iuran Peserta',
                dataType: 'number',
                format: '#,##0.00',
                alignment: 'right'
            },
            {
                dataField: 'iuranPkTotal',
                caption: 'Iuran PK',
                dataType: 'number',
                format: '#,##0.00',
                alignment: 'right'
            },
            {
                dataField: 'iuranLainTotal',
                caption: 'Iuran Lain',
                dataType: 'number',
                format: '#,##0.00',
                alignment: 'right'
            },
            {
                dataField: 'iuranTotal',
                caption: 'Total Iuran',
                dataType: 'number',
                format: '#,##0.00',
                alignment: 'right'
            },
            {
                dataField: 'statusId',
                caption: 'Status',
                lookup: {
                    dataSource: [
                        {
                            id: 1,
                            value: 'Checked'
                        },
                        {
                            id: 2,
                            value: 'Approve'
                        }
                    ],
                    valueExpr: 'id',
                    displayExpr: 'value'
                }
            }
        ]
    }

    componentWillMount() {
        let store = this.props.store;
        store.dispatch(addURL(this.props.location.pathname))
    }

    onToolbarPreparing = (e) => {
        e.toolbarOptions.items.unshift(
            {
                location: 'after',
                widget: 'dxButton',
                options: {
                    icon: 'upload',
                    text: 'Upload File Iuran',
                    elementAttr: { class: "bg-button-upload-dapen-default" },
                    onClick: (e) => {
                        this.uploadIuranRef.current.show()
                    }
                }
            },
        )
    }

    forceRefresh = () => {
        this.dataGridRef.current.forceRefresh(true)
    }

    showModalKirim = (data, type) => {
        this.modalKirimRef.current.show()
        this.modalKirimRef.current.retrieveData(data, type)
    }
    showModalDetilIuranBulanan = (data) => {
        this.modalDetailIuranBulananRef.current.show()
        this.modalDetailIuranBulananRef.current.retrieveData(data)
    }

    processBatalIuran = async (data) => {
        try {
            await httpRequest(process.env.REACT_APP_BACKEND_CORE, this.props.store, 'participant-iuran-uploads/cancel', 'DELETE', data.id);
            this.forceRefresh();
            notify({ message: "Sukses membatalkan data", width: 'AUTO', shading: true, position: { at: 'center', my: 'center', of: window } }, "success", 1000);
        } catch (error) {
            console.log(error);
            notify({ message: "Terjadi Kesalahan", width: "AUTO", shading: true, position: { at: "center", my: "center", of: window } }, 'error', 1000);
        }
    }

    render() {
        return (
            <div className="container-fluid">
                <h2 className="main-title">Upload Data Iuran Bulanan</h2>

                <DevExpressDataGrid
                    ref={this.dataGridRef}
                    loadAPI={`wp/iuran-bulanans?participantId.equals=${this.participantId}`}
                    insertAPI='wp/iuran-bulanans'
                    updateAPI='wp/iuran-bulanans'
                    deleteAPI='wp/iuran-bulanans'

                    backendserver={process.env.REACT_APP_BACKEND_CORE}
                    remoteOperations={true}

                    // useArraySource={true}
                    // ArraySourceData={this.loadDummyData}

                    allowAdding={false}
                    allowDeleting={false}
                    allowUpdating={false}

                    exportExcel={false}
                    exportFileName={"Iuran Bulanan"}
                    allowExportSelectedData={true}
                    selection={"multiple"}

                    showBorders={true}

                    paging={true}
                    defaultPageSize={10}
                    height={'80vh'}

                    //bagian konfigurasi popup saat insert dan edit record
                    popupTitle={'Iuran Bulanan'}
                    popupWidth={700} //masukan dalam ukuran pixel
                    popupHeight={500} //masukkan dalam ukuran pixel

                    popupFormLabelLocation='left' //accepted value = top, left, right
                    popupFormMinColWidth={300} // minimum lebar kolom
                    popupFormColCount={3} //jumlah kolom pada form

                    //akhir bagian konfigurasi popup

                    ColumnChooser={true} // set false agar kolom tidak dapat di pindah pindah
                    ColumnFixing={true} // set false agar kolom tidak dapat di freeze

                    FilterRow={true} // set false untuk mematikan fitur filter

                    ColumnConfiguration={this.columns} // taruh konfigurasi kolom disini
                    SummaryConfiguration={this.summary}

                    onToolbarPreparing={this.onToolbarPreparing}

                    //contoh konfigurasi kolom
                    //this.columns = [{
                    //    dataField: 'kolom1',
                    //    caption: 'Ini Kolom 1'
                    //}, {
                    //    dataField: 'kolom2',
                    //    caption: 'Ini Kolom 2'
                    //}]
                    // detail konfigurasi dapat dilihat di https://js.devexpress.com/Documentation/ApiReference/UI_Widgets/dxDataGrid/Configuration/columns/

                    store={this.props.store} // jangan di edit edit
                />

                <ModalUploadiuran
                    ref={this.uploadIuranRef}
                    store={this.props.store}
                    forceRefresh={this.forceRefresh}
                />
                <ModalKirimIuranBulanan
                    ref={this.modalKirimRef}
                    store={this.props.store}
                    forceRefresh={this.forceRefresh}
                />
                <ModalDetailIuranBulanan
                    ref={this.modalDetailIuranBulananRef}
                    store={this.props.store}
                    forceRefresh={this.forceRefresh}
                />
            </div>
        )
    }
}

export default IuranBulanan
